import Phaser from 'phaser';
import EDC from '../../shared/globals';
import { AnswerMark } from '../../shared/mark-animation';

/**
 *
 */
EDC.Games.DragImagesToMatch.Item = function (scene, id, isShadow = false) {
  this.id = id;
  this.scene = scene;
  this.container = null;
  this.isShadow = isShadow;
  this.isLocked = false;
  this.markAnim = null;
  this.cursorManager = scene.cursorManager;
  this.shadows = null;
  this.target = null;
  return this;
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.create = function () {
  this.container = this.scene.add.container();
  this.container.depth = this.isShadow ? 0 : 1;
  this.container.setData('originX', 0);
  this.container.setData('originY', 0);
  const typeIndex = this.scene.getTypeOfAssets();
  let type = this.scene.gameConfig.assets[typeIndex].type;
  let name = this.isShadow ? `${type}-shadow-` : `${type}-`;
  let itemSprite = this.scene.add.sprite(0, 0, name + this.id);
  let itemBack = this.scene.add.graphics();
  itemBack.fillStyle(0x000000, 0.3);
  itemBack.fillRoundedRect(
    -itemSprite.width / 2,
    -itemSprite.height / 2,
    itemSprite.width,
    itemSprite.height,
    50,
  );
  this.container.add([itemBack, itemSprite]);
  if (!this.isShadow) this.makeDraggable();

  if (!this.isShadow) this.markAnim = new AnswerMark(this.scene, this.container).setScale(0.45);

  return this;
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.setPosition = function (x, y) {
  this.container.setData('originX', x);
  this.container.setData('originY', y);
  this.container.setPosition(x, y);
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.makeDraggable = function () {
  const bounds = this.container.getBounds();
  this.container.setInteractive(
    new Phaser.Geom.Rectangle(-bounds.width / 2, -bounds.height / 2, bounds.width, bounds.height),
    Phaser.Geom.Rectangle.Contains,
  );
  this.scene.input.setDraggable(this.container);

  this.cursorManager.setDefaultDraggableEvents(this.container);

  this.container.on(
    'drag',
    ((obj, pointer) => {
      obj.setPosition(pointer.x, pointer.y);
    }).bind(this, this.container),
  );
  this.container.on(
    'dragstart',
    ((container) => {
      container.depth = 3;
    }).bind(this, this.container),
  );
  this.container.on(
    'dragend',
    function (container) {
      container.depth = 1;
      const shadow = this.scene.getShadowUnderPointer(this.container);
      if (shadow) {
        const shadowContainer = shadow.getContainer();
        const x  = shadowContainer.x;
        const y = shadowContainer.y;
        if (this.id === shadow.id) {
          this.moveTo(x, y, 100);
          this.scene.input.setDraggable(this.container, false);
          this.markAnim.showMark(
            true,
            () => {
              shadow.isTaken = true;
              this.isLocked = true;
              this.container.removeInteractive();
              this.cursorManager.resetCursor();
              this.scene.checkIterationDone();
              this.scene.incrementAnswersCounter(false);
            },
          );
        } else if (shadow.isTaken) {
          this.backToOrigin();
        } else {
          this.moveTo(x, y, 100);
          this.markAnim.showMark(
            false,
            () => {
              this.markAnim.reset();
              this.backToOrigin();
              this.scene.incrementAnswersCounter(true);
            },
          );
        }
      } else {
        this.backToOrigin();
      }
    }.bind(this, this.container),
  );

  this.scene.time.delayedCall(1050, this.getTargetShadow, [], this);
};
EDC.Games.DragImagesToMatch.Item.prototype.getTargetShadow = function () {
  this.shadows = this.scene.shadows;
  for (let i = 0; i < this.shadows.length; i++) {
    const res = this.shadows[i];
    if (res.id === this.id) this.target = res.getContainer();
  }
  const bounds = this.target.getBounds();
  const width = bounds.width;
  const height = bounds.height;

  this.target.overlapArea = new Phaser.Geom.Rectangle(
    this.target.x,
    this.target.y,
    this.target.displayWidth,
    this.target.displayHeight,
  );
};

/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.moveTo = function (x, y, duration = 200) {
  this.scene.tweens.add({
    targets: this.container,
    x,
    y,
    duration,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.backToOrigin = function () {
  const x = this.container.getData('originX');
  const y = this.container.getData('originY');
  this.moveTo(x, y, 300);
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.getContainer = function () {
  return this.container;
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.destroy = function () {
  this.container.destroy();
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.getWidth = function () {
  const bounds = this.container.getBounds();
  return bounds.width;
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.getHeight = function () {
  const bounds = this.container.getBounds();
  return bounds.height;
};
/**
 *
 */
EDC.Games.DragImagesToMatch.Item.prototype.isContainPoint = function (container) {
  const bounds = this.container.getBounds();
  bounds.y += 20;
  if (Phaser.Geom.Intersects.RectangleToRectangle(bounds, container.getBounds())) {
    return true;
  }
  return false;
};

export default EDC.Games.DragImagesToMatch.Item;
